function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.117.003L6.094 0C3.82 0 2.352 1.535 2.352 3.912v1.803H.318A.321.321 0 000 6.04v2.614c0 .179.142.324.318.324h2.034v7.539c0 .179.143.324.318.324h2.654a.321.321 0 00.318-.324v-7.54h2.379a.321.321 0 00.318-.323V6.039a.328.328 0 00-.092-.229.315.315 0 00-.226-.095H5.642V4.186c0-.735.172-1.108 1.112-1.108h1.363a.321.321 0 00.317-.324V.327a.321.321 0 00-.317-.324z",
  fill: "currentColor",
  fillRule: "evenodd"
});

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 9 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgFacebook;